import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';

// Clip

const updateMetadataClipStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_START
    };
};


const updateMetadataClipSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_SUCCESS
    };
};


const updateMetadataClipFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_FAIL,
        error: error
    };
};

// Project

const updateMetadataProjectStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_START
    };
};

const updateMetadataProjectSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_SUCCESS
    };
};

const updateMetadataProjectFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_FAIL,
        error: error
    };
};

// Distribution

const updateMetadataDistributionStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_START
    };
};

const updateMetadataDistributionSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_SUCCESS
    };
};

const updateMetadataDistributionFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_FAIL,
        error: error
    };
};


// Article

const updateMetadataArticleStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ARTICLE_START
    };
};

export const updateMetadataArticleSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ARTICLE_SUCCESS
    };
};

const updateMetadataArticleFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_ARTICLE_FAIL,
        error: error
    };
};

// Room

const updateMetadataRoomStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_START
    };
};

const updateMetadataRoomSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_SUCCESS
    };
};

const updateMetadataRoomFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_FAIL,
        error: error
    };
};

// Config

const loadMetadataConfigStart = () => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_START
    };
};

const loadMetadataConfigSuccess = (config) => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_SUCCESS,
        config: config
    };
};

const loadMetadataConfigFail = (error) => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_FAIL,
        error: error
    };
};

export const resetMetadataConditional = () => {
    return dispatch => {
        dispatch({ type: actionTypes.METADATA_CONDITIONAL_RESET });
    }
};

export const loadMetadataConfig = (local = true) => {
    return dispatch => {
        if (local) {
            console.log("LOAD LOCAL METADATA CONFIG");
            dispatch(loadMetadataConfigStart());
            import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then((module) => {
                dispatch(loadMetadataConfigSuccess(module));
            }).catch((res) => {
                dispatch(loadMetadataConfigFail(res.message));
            });
        } else {
            console.log("LOAD EXTERNAL METADATA CONFIG");

            // TODO
            // remove and implement correct process to load config from server

            dispatch(loadMetadataConfigStart());
            import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then((module) => {
                dispatch(loadMetadataConfigSuccess(module));
            }).catch((res) => {
                dispatch(loadMetadataConfigFail(res.message));
            });
        }
    }
};

export const loadSoapApiDef = () => {
    return dispatch => {
        dispatch({ type: actionTypes.LOAD_SOAP_API_DEF_START });
        window.flow.getSoapapidef().then((apiDef) => {
            dispatch({ type: actionTypes.LOAD_SOAP_API_DEF_SUCCESS, apiDef: apiDef });
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.LOAD_SOAP_API_DEF_FAIL });
        });
    }
}

export const saveMetadataConfig = (user, config, type) => {
    return dispatch => {
        let field = "";

        switch (type) {
            case Metadata.OBJECT_TYPE_PROJECT:
                field = "metadata_project";
                break;
            case Metadata.OBJECT_TYPE_CLIP:
            default:
                field = "metadata_clip";
                break;
        }

        dispatch({ type: actionTypes.SAVE_METADATA_CONFIG_START });
        window.flow.grantingEditUser(user.groupid, user.id, [
            { 'name': field, 'value': config }
        ], true).then((res) => {
            console.log("saveMetadataConfigSuccess", res);
            dispatch({ type: actionTypes.SAVE_METADATA_CONFIG_SUCCESS });
            dispatch({ type: actionTypes.UPDATE_METADATA_CONFIG, config: JSON.parse(config), field: type });
        }).catch(res => {
            dispatch({ type: actionTypes.SAVE_METADATA_CONFIG_FAIL });
            console.log("saveMetadataConfigFail");
        });
    }
}

export const updateMetadata4Upload = (type, id, metadata) => {
    return (dispatch, getState) => {
        switch (type) {
            case Metadata.OBJECT_TYPE_CLIP:
                window.flow.editClip(id, metadata).then((clip) => {
                    if (clip && clip.mediafiles && clip.mediafiles.elements) {
                        dispatch({ type: actionTypes.UPLOAD_UPDATE_METADATA, payload: { mediafiles: clip.mediafiles.elements } });
                        dispatch(actions.getClipLimit(getState().app.modules.modules));
                    }
                }).catch((res) => {
                    console.log(res);
                });
                break;
            default:
                break;
        }
    }
};



export const updateMetadata = (type, id, metadata, reloads/*, reload = true*/) => {
    console.log(type, id, metadata);
    return (dispatch, getState) => {
        switch (type) {
            case Metadata.OBJECT_TYPE_PROJECT:
                console.log("LAMTEST UPDATE PROJECT");
                dispatch(updateMetadataProjectStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editProject(id, metadata).then((project) => {
                    console.log("SUCCESS");
                    console.log(project);
                    dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project });
                    dispatch(updateMetadataProjectSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    // reload projects
                    dispatch(actions.getProjectTree());
                    dispatch(actions.getProjects());
                    //dispatch(actions.getDeletedProjects());

                    //dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project });
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataProjectFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_DISTRIBUTION:
                dispatch(updateMetadataDistributionStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editDistproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    dispatch(updateMetadataDistributionSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    // reload distributions
                    dispatch(actions.getDistributionByDist());
                    dispatch(actions.getDistributionTree());

                    //dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project});
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataDistributionFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_ARTICLE:
                dispatch(actions.updateArticleMetadata({ id, metadata }));
                break;
            case Metadata.OBJECT_TYPE_NEWSROOM:
                console.log("UPDATE NEWSROOM");
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editNewsroomproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    // reload newsrooms
                    dispatch(actions.getNewsroomTree());

                    dispatch(actions.getRoomLimit(getState().app.modules.modules));
                }).catch((res) => {
                    console.log(res);
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_PM:
                console.log("UPDATE PM");
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editDistproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    dispatch({ type: actionTypes.DISTRIBUTION_METADATA_UPDATE, dist: res, distType: 'pmdb_pm' });
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    // reload pm
                     // TODO: think about better solution - not clean implemenmtation
                    if(reloads && Array.isArray(reloads)) {
                        reloads.forEach(reload => reload());
                    }
                    //dispatch(actions.getDistributionByDistWithType('pmdb_pm'));
                }).catch((res) => {
                    console.log(res);
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_WPS:
                console.log("UPDATE WPS");
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editDistproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    dispatch({ type: actionTypes.DISTRIBUTION_METADATA_UPDATE, dist: res, distType: 'pmdb_wps' });
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    // reload pm
                    // TODO: think about better solution - not clean implemenmtation
                    if(reloads && Array.isArray(reloads)) {
                        reloads.forEach(reload => reload());
                    }
                    //dispatch(actions.getDistributionByDistWithType('pmdb_wps'));
                }).catch((res) => {
                    console.log(res);
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_RENT:
                console.log("UPDATE RENT");
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editDistproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    console.log(res);
                    dispatch({ type: actionTypes.DISTRIBUTION_METADATA_UPDATE, dist: res, distType: 'padb_rent' });
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    // reload pm
                    //dispatch(actions.getDistributionByDistWithType('padb_rent'));
                }).catch((res) => {
                    console.log(res);
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_ROOM:
                console.log("UPDATE ROOM");
                dispatch(updateMetadataRoomStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editShowroom(id, metadata).then((room) => {
                    console.log("SUCCESS");
                    console.log(room);
                    dispatch({ type: actionTypes.ROOM_UPDATE_RECEIVED, room: room });
                    dispatch(updateMetadataRoomSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    dispatch({ type: actionTypes.METADATA_RESET });
                    // reload rooms
                    dispatch(actions.getRooms());
                    dispatch(actions.getDeletedRooms());

                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataRoomFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_CLIP:
                dispatch(updateMetadataClipStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                console.log(id);
                window.flow.editClip(id, metadata).then((clip) => {
                    console.log("SUCCESS clip", clip);
                    if (clip.hasOwnProperty('success')) {
                        console.log('FAIL CONDITIONAL');
                        if (!clip.success) {
                            dispatch({ type: actionTypes.METADATA_CONDITIONAL_FAIL, msg: clip.msg, fields: clip.data.fields });
                            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                            dispatch({ type: actionTypes.METADATA_RESET });
                        }
                    } else {
                        dispatch(updateMetadataClipSuccess());
                        dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                        dispatch({ type: actionTypes.METADATA_RESET });
                    }

                    let ids = id;
                    // make string and split to array to find value
                    if (!Array.isArray(ids)) {
                        ids = (ids + "").split(',');
                    }

                    if (ids.length > 1) {
                        dispatch(actions.getCliplistByIds(ids));
                    } else {
                        dispatch(actions.getClipById(ids[0]));
                    }

                    // reload clips
                    /*ids.forEach((clipId) => {
                        dispatch(actions.getClipById(clipId));
                    });*/

                    if (reloads) {
                        dispatch(actions.reloadComponent(reloads.components, reloads.id));
                    }
                    dispatch(actions.getClipLimit(getState().app.modules.modules));
                    //dispatch({ type: actionTypes.CLIP_UPDATE_RECEIVED, clip: clip });
                }).catch((res) => {
                    console.log(id, res);
                    dispatch(updateMetadataClipFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_UPLOADPROJECT:
                dispatch(actions.updateUploadProjectMetadata({ id, metadata }));
                break;
            case Metadata.OBJECT_TYPE_EVENTROOM:
                dispatch(actions.updateEventRoomMetadata({ id, metadata }));
                break;
            default:
                break;
        }

    }
};

const MASS_UPDATE_MAX_TRIES = 3;

export const massUpdateMetadata = (objs, tries = 1) => {
    return (dispatch, getState) => {
        console.log("MASSEDIT START", tries, objs);

        const state = initMassUpdateStatus(dispatch, objs, tries);

        for (let id in objs) {
            window.flow.editClip(id, objs[id]).then((clip) => {
                massUpdateSuccess(state);
                massUpdateCheck(dispatch, state, tries);
            }).catch((res) => {
                massUpdateFail(state, id, objs[id]);
                massUpdateCheck(dispatch, state, tries);
            });
        }
    }
}

const initMassUpdateStatus = (dispatch, objs, tries) => {
    const state = {
        count: Object.keys(objs).length,
        done: 0,
        success: 0,
        fail: {}
    }

    const message = {
        operation: "BATCH PROCESSING",
        try: tries,
        ...state,
        fail: Object.keys(state.fail).length
    };

    dispatch({ type: actionTypes.STATUSBAR_SET_MESSAGE, message: message });

    state.change = {};
    state.change.success = document.getElementById('success');
    state.change.done = document.getElementById('done');
    state.change.fail = document.getElementById('fail');

    return state;
}

const massUpdateSuccess = (state) => {
    state.done++;
    state.success++;

    state.change.done.textContent = state.done;
    state.change.success.textContent = state.success;
    console.log("SUCCESS " + state.success, "FAIL " + Object.keys(state.fail).length);
}

const massUpdateFail = (state, id, obj) => {
    state.done++;
    state.fail[id] = obj;

    state.change.done.textContent = state.done;
    state.change.fail.textContent = Object.keys(state.fail).length;
    console.log("SUCCESS " + state.success, "FAIL " + Object.keys(state.fail).length);
}

const massUpdateCheck = (dispatch, state, tries) => {
    if (state.count === state.done) {
        if (Object.keys(state.fail).length) {
            if (tries < MASS_UPDATE_MAX_TRIES) {
                dispatch(actions.massUpdateMetadata(state.fail, tries + 1));
            } else {
                const exception = {
                    title: "popup.title.massedit.fail",
                    message: "popup.message.massedit.fail",
                    info: Object.keys(state.fail).join(', '),
                    cancel: true,
                    callback: () => {
                        dispatch({ type: actionTypes.STATUSBAR_RESET_EXCEPTION });
                        dispatch(actions.massUpdateMetadata(state.fail));
                    },
                    dismiss: () => {
                        dispatch({ type: actionTypes.STATUSBAR_RESET_EXCEPTION });
                    }
                }

                dispatch({ type: actionTypes.STATUSBAR_SET_EXCEPTION, exception: exception });
            }
        } else {
            dispatch({ type: actionTypes.STATUSBAR_RESET_MESSAGE });
        }
    }
}

// CHECK IF BETTER TO SET COMPLETE OBJECT AS PARAM TO GET id AND originalElements

export const initMetadataChange = (type, id, originalElements) => {
    return dispatch => {
        dispatch({
            type: actionTypes.METADATA_INIT_CHANGE,
            data: {
                type: type,
                id: id,
                elements: originalElements
            }
        });
    }
}

export const changeMetadata = (type, id, changedElements, originalElements) => {
    return dispatch => {
        console.log(type, id, changedElements);
        dispatch({
            type: actionTypes.METADATA_CHANGE,
            data: {
                type: type,
                id: id,
                elements: changedElements
            }
        });
    }
}

export const resetMetadata = (type, id) => {
    return dispatch => {
        console.log("RESET");
        dispatch({
            type: actionTypes.METADATA_RESET,
            data: {
                type: type,
                id: id
            }
        });
    }
}

export const reloadComponent = (reloads, id) => {
    return dispatch => {
        if (reloads.length) {
            reloads.forEach(component => {
                if (component === Metadata.OBJECT_TYPE_PROJECT && id) {
                    dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_PROJECT, id));
                }
                if (component === Metadata.OBJECT_TYPE_SERIES) {
                    dispatch(actions.getSeriesTree());
                }
            });
        }
    }
};

export const addMemberToProject = (id, member) => {
    return ((dispatch) => {
        console.log(id, member);
        dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_START });
        //dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectAddMember(id, member).then((project) => {
            dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_SUCCESS });
            dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project });
            //dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        }).catch((res) => {
            //dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_FAIL, error: res.message });
        });
    });
}


export const delMemberFromProject = (projectId, memberId) => {
    return (dispatch => {
        console.log(projectId, memberId);
        dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_START });
        //dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectDelMember(projectId, memberId).then(project => {
            dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_SUCCESS });
            dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project });
            //dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        }).catch(res => {
            //dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_FAIL, error: res.message });
        })
    })
}
